module.exports = __webpack_public_path__ + "static/media/player_level_S.3245fb5d.png";